import { contactLinks } from "../config/appConfig";
import { AppNavbar, Footer } from "../components";

const CancellationRefundPolicy = () => {
  return (
    <div className="min-h-screen flex flex-col justify-between gap-5 overflow-hidden">
      <AppNavbar />

      <main className="container mx-auto px-5 py-20 space-y-5">
        <h1 className="font-Montserrat text-wabmBlue text-3xl text-center font-bold">
          Cancellation and Refund Policy
        </h1>
        <div className="space-y-3">
          <h3 className="font-Montserrat text-lg">Cancellation Policy</h3>
          <p className="text-justify">
            ▸ WaBM no longer operates on recurring subscription plans. Instead,
            users recharge coins to their WaBM account and consume those coins
            when they perform certain actions.
          </p>
          <p className="text-justify">
            ▸ You may close or deactivate your WaBM account at any time by
            contacting our customer support team. Closing or deactivating your
            account does not entitle you to a refund of any remaining coins or
            past payments (unless an exception is made as described in the
            Refund Policy below).
          </p>
          <p className="text-justify">
            ▸ If you stop using the service after recharging, coins already
            purchased and credited to your account will remain in the account
            balance unless stated otherwise on the feature pricing page. Coins
            are consumed only for actions and features listed on the feature
            pricing page (for example: message template sending, new user
            creation, auto-replies, business card detection, etc.).
          </p>
          <p className="text-justify">
            ▸ WaBM reserves the right to suspend or terminate your account at
            any time, without notice, for any violation of our Terms of Service
            or Acceptable Use Policy. Account suspension or termination will not
            automatically result in a refund of remaining coin balance.
          </p>

          <h3 className="font-Montserrat text-lg">Recharge &amp; Coin Usage</h3>
          <p className="text-justify">
            ▸ Coins are purchased through one-time recharges. Your coin balance
            will be debited according to the usage and pricing rules listed on
            our feature pricing page. Please review the pricing page carefully
            to understand which actions consume coins and how many coins each
            action uses.
          </p>
          <p className="text-justify">
            ▸ Pricing, coin deductions, and any special validity or expiration
            rules for coins (if applicable) will be detailed on the feature
            pricing page. Where the pricing page provides a different rule (for
            example, temporary promotional credits or expiration), that rule
            will apply.
          </p>

          <h3 className="font-Montserrat text-lg">Refund Policy</h3>
          <p className="text-justify">
            ▸ WaBM does not provide refunds for coins or payments if you choose
            to stop using the service or decide not to continue. All purchases
            of coins and one-time recharges are final except as described below.
          </p>
          <p className="text-justify">
            ▸ Refunds will only be considered and issued in the event of a
            verified technical issue, outage, or error caused directly by WaBM
            that has materially prevented you from using the service for an
            extended period. Proof of the issue and relevant transaction details
            may be required.
          </p>
          <p className="text-justify">
            ▸ If a refund is approved, refunds will be processed to the original
            payment method or an alternate method at our discretion, and will
            generally be completed within 14 business days of approval.
          </p>
          <p className="text-justify">
            ▸ WaBM is not responsible for third-party fees, foreign exchange
            differences, bank fees, or processing fees charged by payment
            providers. Any such fees are non-refundable unless explicitly stated
            otherwise.
          </p>

          <h3 className="font-Montserrat text-lg">
            Erroneous Charges &amp; Disputes
          </h3>
          <p className="text-justify">
            ▸ If you believe you were charged in error (for example, duplicate
            charges or incorrect amounts), please contact our support team
            immediately with the transaction ID, date, amount, and a short
            description. We will investigate and, if the charge is found to be
            an error on our side, correct it and refund the affected amount.
          </p>
          <p className="text-justify">
            ▸ If a payment dispute or chargeback is initiated with your bank or
            payment provider, WaBM may pause or restrict your account while we
            investigate. Repeated or abusive chargebacks may result in
            termination of service.
          </p>

          <h3 className="font-Montserrat text-lg">
            Account Credits, Promotions &amp; Adjustments
          </h3>
          <p className="text-justify">
            ▸ Promotional credits, bonuses, or trial coins (if any) are subject
            to the specific terms associated with those promotions. Unless the
            promotion specifies otherwise, promotional credits are not
            redeemable for cash and are non-transferable.
          </p>
          <p className="text-justify">
            ▸ Any manual account adjustments made by WaBM (for example to
            correct a billing error) are at our discretion.
          </p>

          <h3 className="font-Montserrat text-lg">Contact Us</h3>
          <p className="text-justify">
            If you have any questions, believe there has been an error, or need
            help with a refund request, please contact our customer support team
            for assistance or email us at {contactLinks.supportMail}.
          </p>

          <p className="text-justify italic">Last updated: 2025-09-12</p>
        </div>
      </main>

      <Footer />
    </div>
  );
};

export default CancellationRefundPolicy;
